interface SearchResult {
  uuid: string;
  title: string;
  summary: string;
  slug: string;
  categories: string[];
}

interface SearchResponse {
  data: SearchResult[];
  total: number;
}

export function initKnowledgeBaseSearch(): void {
  const input = document.getElementById('kb-search') as HTMLInputElement | null;
  const resultsList = document.getElementById('kb-search-results') as HTMLUListElement | null;

  if (!input || !resultsList) return;

  let debounceTimer: ReturnType<typeof setTimeout>;

  input.addEventListener('input', () => {
    clearTimeout(debounceTimer);
    const query = input.value.trim();

    if (query.length < 2) {
      resultsList.hidden = true;
      resultsList.innerHTML = '';
      return;
    }

    debounceTimer = setTimeout(() => fetchResults(query), 250);
  });

  input.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      resultsList.hidden = true;
      resultsList.innerHTML = '';
    }
  });

  document.addEventListener('click', (e) => {
    if (!input.contains(e.target as Node) && !resultsList.contains(e.target as Node)) {
      resultsList.hidden = true;
    }
  });

  async function fetchResults(query: string): Promise<void> {
    try {
      const res = await fetch(`/api/articles/search?q=${encodeURIComponent(query)}`);
      if (!res.ok) {
        resultsList.hidden = true;
        return;
      }
      const data: SearchResponse = await res.json();
      renderResults(data.data);
    } catch {
      resultsList.hidden = true;
    }
  }

  function renderResults(results: SearchResult[]): void {
    resultsList.innerHTML = '';

    if (results.length === 0) {
      const li = document.createElement('li');
      li.style.padding = '.75rem 1rem';
      li.style.color = 'var(--text-muted)';
      li.textContent = 'Geen resultaten gevonden.';
      resultsList.appendChild(li);
      resultsList.hidden = false;
      return;
    }

    results.forEach((result) => {
      const li = document.createElement('li');
      li.style.cssText = 'padding:.6rem 1rem;cursor:pointer;border-bottom:1px solid var(--border)';

      const title = document.createElement('strong');
      title.style.display = 'block';
      title.textContent = result.title;

      const summary = document.createElement('span');
      summary.style.cssText = 'display:block;font-size:.85rem;color:var(--text-muted);margin-top:.15rem';
      summary.textContent = result.summary.length > 80
        ? result.summary.slice(0, 80) + '…'
        : result.summary;

      li.appendChild(title);
      li.appendChild(summary);

      li.addEventListener('click', () => {
        window.location.href = `/kennisbank/${encodeURIComponent(result.slug)}`;
      });

      li.addEventListener('mouseenter', () => {
        li.style.background = 'var(--surface-2)';
      });
      li.addEventListener('mouseleave', () => {
        li.style.background = '';
      });

      resultsList.appendChild(li);
    });

    resultsList.hidden = false;
  }
}
